// todo sasha type generation
export enum WorkflowType {
  LE_VLEI_PREREQ = 'LE_VLEI_PREREQ',
  OOR_VLEI_PREREQ = 'OOR_VLEI_PREREQ',
  ECR_VLEI_PREREQ = 'ECR_VLEI_PREREQ'
}
